import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { getMonthName } from "utils/date";

const ApexChart = ({ items }) => {
  const [chartState, setChartState] = useState({
    series: [
      {
        name: "Ventas mensuales",
        data: items.map((item) => item.totalOrderPrice),
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: items.map((item) => getMonthName(item.month.split("-")[1])),
        labels: {
          style: {
            colors: "#fff", // Color for x-axis labels
          },
        },
      },
      yaxis: {
        title: {
          text: "Total $",
          style: {
            color: "#fff", // Color for y-axis title
          },
        },
        labels: {
          formatter: function (val) {
            return val.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            });
          },
          style: {
            colors: "#fff", // Color para las etiquetas del eje y
          },
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return val.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
            });
          },
        },
      },
    },
  });

  return (
    <ReactApexChart
      options={chartState.options}
      series={chartState.series}
      type="bar"
      height={350}
    />
  );
};

export default ApexChart;
